import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class SharedFormService {
    public form!: FormGroup;

    constructor(private fb: FormBuilder) {
        this.initForm(); // Chiamata iniziale per assicurare che form sia inizializzato al primo caricamento
    }

    initForm(): void {
        this.form = this.fb.group({
            anagraficaForm: this.fb.group({
                sesso: ['', Validators.required],
                nome: ['', Validators.required],
                cognome: ['', Validators.required],
                codiceFiscale: ['', [Validators.required, Validators.pattern('^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z][0-9]{3}(?:[A-Za-z]|Z[0-9]{3})$')]],
                etaCompiuta: ['', Validators.required]
            }),
            parteA: this.fb.group({
                fkLuogoDecesso: ['', Validators.required],
                luogoDecessoAltro: [''],
                territorioDecesso: this.fb.group({
                    fkComuneDecesso: ['', Validators.required],
                    fkComuneDecessoDescr: ['', Validators.required],
                    provincia: ['', Validators.required],
                    codiceAslDecesso: ['', Validators.required],
                    descrAslDecesso: ['']
                }),
                fkStatoGravidanza: [''],
                riscontroDiagnostico: ['', Validators.required],
                causaIniziale: this.fb.group({
                    i_xix_1: [''],
                    i_xix_2: [''],
                    i_xix_3: [''],
                    i_xix_4: [''],
                    xx_1: [''],
                    xx_2: [''],
                    xx_3: [''],
                    xx_4: [''],
                }),
                causaMortePatologia: this.fb.group({
                    causaDiMorte1Cod: ['', Validators.required],
                    causaDiMorte1: ['', Validators.required],
                    causaDiMorte1Anni: [''],
                    causaDiMorte1Mesi: [''],
                    causaDiMorte1Giorni: ['']
                }),
                causaMorteCondizioni: this.fb.group({
                    condizione1: this.fb.group({
                        causaDiMorte2Cod: [''],
                        causaDiMorte2: [''],
                        causaDiMorte2Anni: [''],
                        causaDiMorte2Mesi: [''],
                        causaDiMorte2Giorni: ['']
                    }),
                    condizione2: this.fb.group({
                        causaDiMorte3Cod: [''],
                        causaDiMorte3: [''],
                        causaDiMorte3Anni: [''],
                        causaDiMorte3Mesi: [''],
                        causaDiMorte3Giorni: ['']
                    }),
                    condizione3: this.fb.group({
                        causaDiMorte4Cod: [''],
                        causaDiMorte4: [''],
                        causaDiMorte4Anni: [''],
                        causaDiMorte4Mesi: [''],
                        causaDiMorte4Giorni: ['']
                    })
                }),
                altriStatiMorbosi: this.fb.group({
                    stato1: this.fb.group({
                        statiMorbosi1Cod: [''],
                        statiMorbosi1: [''],
                        statiMorbosi1Anni: [''],
                        statiMorbosi1Mesi: [''],
                        statiMorbosi1Giorni: ['']
                    }),
                    stato2: this.fb.group({
                        statiMorbosi2Cod: [''],
                        statiMorbosi2: [''],
                        statiMorbosi2Anni: [''],
                        statiMorbosi2Mesi: [''],
                        statiMorbosi2Giorni: ['']
                    }),
                    stato3: this.fb.group({
                        statiMorbosi3Cod: [''],
                        statiMorbosi3: [''],
                        statiMorbosi3Anni: [''],
                        statiMorbosi3Mesi: [''],
                        statiMorbosi3Giorni: ['']
                    })
                }),
                eventoTraumatismo: ['F'],
                eventoOrigineTraumatismo: [''],
                fkModalitaTraumatismo: [''],
                traumatismoSulLavoro: [''],
                incidenteTrasporti: this.fb.group({
                    incidenteTrasportoMezzo: [''],
                    fkIncidenteTrasportoRuolo: [''],
                    incidenteTrasportoTipo: [''],
                    incidenteTrasportoScontro: ['']
                }),
                dataEvento: this.fb.group({
                    orarioEventoHh: ['', [Validators.min(0), Validators.max(23)]],
                    orarioEventoMm: ['', [Validators.min(0), Validators.max(59)]],
                    data8selected: new FormControl<Date | null>(null),
                }),
                fkLuogoEvento: [''],
                altroLuogoEvento: [''],
                dichiarazioni: this.fb.group({
                    dataCompilazione: new FormControl<Date | null>(null, Validators.required),
                    nomeCognomeMedico: ['', Validators.required],
                    telefonoRiferimento: ['', Validators.required],
                    fkTipoMedico: ['', Validators.required],
                })
            }),
            parteB: this.fb.group({
                attoMorteNumero: ['', Validators.required],
                parte1: [''],
                serie1: [''],
                circoscrizione: [''],
                denominazione: this.fb.group({
                    fkComune: ['', Validators.required],
                    fkComuneDescr: ['', Validators.required],
                    provincia: ['', Validators.required]
                }),
                dataMorte: this.fb.group({
                    dataMorteHh: ['', [Validators.min(0), Validators.max(23), Validators.required]],
                    dataMorteMm: ['', [Validators.min(0), Validators.max(59), Validators.required]],
                    data: new FormControl<Date | null>(null, Validators.required),
                }),
                dataNascita: new FormControl<Date | null>(null, Validators.required),
                fkLocalitaNascita: ['', Validators.required],
                altroComuneNascita: this.fb.group({
                    fkLocalitaComuneNascita: [''],
                    fkLocalitaComuneNascitaDescr: [''],
                    provincia: ['']
                }),
                fkLocalitaStatoEsteroNascita: [''],
                fkLocalitaStatoEsteroNascitaDescr: [''],
                etaCompiuta: ['', Validators.required],
                fkStatoCivile: ['', Validators.required],
                casiStatoCivile: this.fb.group({
                    annoNascitaConiuge: [''],
                    annoMatrimonioUnione: [''],
                }),
                fkLocalitaResidenza: ['', Validators.required],
                altroComuneResidenza: this.fb.group({
                    fkComuneResidenza: [''],
                    fkComuneResidenzaDescr: [''],
                    provincia: ['']
                }),
                fkStatoResidenza: [''],
                fkStatoResidenzaDescr: [''],
                fkGradoIstruzione: ['', Validators.required],
                professione: ['', Validators.required],
                fkCondizioneProfessionale: ['', Validators.required],
                fkPosizioneProfessione: ['', Validators.required],
                lavoratoriAutonomi: [''],
                lavoratoriDipendenti: [''],
                fkRamoAttivitaEconomica: ['', Validators.required],
                fkCittadinanza: ['', Validators.required],
                fkCittadinanzaStatoStraniera: [''],
                cittadinanzaItaliana: [''],
                fkCittadinanzaStatoStranieraDesc: [''],
                firmaRecapitiUfficiale: this.fb.group({
                    recapito: ['', Validators.required],
                    telefono: ['', Validators.required],
                    email: ['', Validators.required]
                })
            }),
            filtro: this.fb.group({
                codiceFiscale: ['', [Validators.required, Validators.pattern('^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$')]],
                nome: [''],
                cognome: [''],
                dataNascita: new FormControl<Date | null>(null),
                dataMorte: new FormControl<Date | null>(null),
                asl: ['']
            })
        });
    }
}
